<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('modals.change_email.title')"
                :content="$t('modals.change_email.content')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>
            <common-content-wrapper width="small">
                <change-email-form
                    @cancel="emitEvent({ name: 'close' })"
                    @success="emitEvent({ name: 'email-changed' })"
                ></change-email-form>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import ChangeEmailForm from 'components/forms/profile/ChangeEmailForm'

    export default {
        components: { ChangeEmailForm },

        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>
